import axios from 'axios';
import { urls } from '../config';
import { contextApp } from 'context';

export const useApiRoutes = () => {
 const { auth } = contextApp();

 const RouteApi = axios.create({
  baseURL: urls.route(),
  headers: { 'x-access-token': auth?.token }
 });

 const getRoutes = async () => (await RouteApi.get('/')).data;

 const getCategories = async (company = '/') => (await RouteApi.get('/categories' + company)).data;

 const createRoute = async newRoutes => (await RouteApi.post('/', newRoutes)).data;

 const updateRoute = async ({ id, ...newRoutes }) => (await RouteApi.patch('/' + id, newRoutes)).data;

 const deleteRoute = async id => (await RouteApi.delete('/' + id)).data;

 return { getRoutes, getCategories, createRoute, updateRoute, deleteRoute };
};
